var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreenMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.703,
    height: 28.703,
    viewBox: "0 0 29.703 28.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fullscreen-Arrow-Arrows-Direction-User_Interface",
    "data-name": "Fullscreen-Arrow-Arrows-Direction-User Interface",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164572",
    "data-name": "Path 164572",
    d: "M46.77,42.535v-6.2a.889.889,0,0,0-.886-.886h-6.2a1.329,1.329,0,1,0,0,2.659h2.553l-6.43,6.43a1.329,1.329,0,0,0,1.879,1.879l6.43-6.43v2.552a1.33,1.33,0,0,0,2.659,0Z",
    transform: "translate(-35.445 -17.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164573",
    "data-name": "Path 164573",
    d: "M46.687,13.505V7.3a1.33,1.33,0,0,0-2.659,0V9.854L37.6,3.423A1.33,1.33,0,1,0,35.718,5.3l6.43,6.43H39.6a1.33,1.33,0,0,0,0,2.659h6.2A.889.889,0,0,0,46.687,13.505Z",
    transform: "translate(-35.295 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164574",
    "data-name": "Path 164574",
    d: "M13.968,5.3a1.329,1.329,0,1,0-1.879-1.879l-6.43,6.43V7.3A1.329,1.329,0,1,0,3,7.3v6.2a.889.889,0,0,0,.886.886h6.2a1.33,1.33,0,0,0,0-2.659H7.538Z",
    transform: "translate(15.312 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164575",
    "data-name": "Path 164575",
    d: "M13.968,46.34a1.327,1.327,0,0,0,0-1.879l-6.43-6.43H10.09a1.329,1.329,0,1,0,0-2.659h-6.2A.889.889,0,0,0,3,36.259v6.2a1.329,1.329,0,0,0,2.659,0V39.91l6.43,6.43A1.329,1.329,0,0,0,13.968,46.34Z",
    transform: "translate(15.312 -17.026)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenMinimize);
export default __webpack_public_path__ + "static/media/Fullscreen-minimize.0c44214fe0527c053bff19e6a4e86660.svg";
export { ForwardRef as ReactComponent };